import classNames from 'classnames';
import React, { useMemo } from 'react';
import { cycle, getNumberOfDigits } from '../helpers';
import { classes } from './chainable-number-input.st.css';
export const ChainableNumberInput = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { value, className, onNext, onPrev, onChange, onKeyDown, onCycle, min, max, ...rest } = props;
    const numberValue = value ? parseInt(value, 10) : 0;
    const updateValue = useMemo(()=>(num)=>{
            if (num === undefined) {
                return onChange('');
            }
            const cycledNum = cycle(num, min, max);
            const formattedValue = cycledNum.toString().padStart(value?.length ?? 0, '0');
            onChange(formattedValue);
            if (cycledNum !== num) {
                onCycle?.(formattedValue);
            }
        }, [
        min,
        max,
        onChange,
        value,
        onCycle
    ]);
    const isFull = useMemo(()=>(str)=>!!str && (str.length >= max.toString().length || parseInt(str, 10) * 10 > max), [
        max
    ]);
    const handleChange = useMemo(()=>(event)=>{
            const filteredValue = event.target.value.match(/[0-9]*/)?.[0] ?? '';
            onChange(filteredValue);
        }, [
        onChange
    ]);
    const handleKeyDown = useMemo(()=>(ev)=>{
            const { selectionStart, selectionEnd } = ev.currentTarget;
            const length = value?.toString().length ?? 0;
            const selectionAtTheEnd = selectionStart === length && selectionEnd === length;
            switch(ev.key){
                case 'ArrowDown':
                    {
                        updateValue(numberValue - 1);
                        break;
                    }
                case 'ArrowUp':
                    {
                        updateValue(numberValue + 1);
                        break;
                    }
                case 'Backspace':
                case 'ArrowLeft':
                    {
                        if (selectionStart === 0 && selectionEnd === 0) {
                            ev.preventDefault();
                            onPrev?.(ev.key);
                        }
                        break;
                    }
                case 'ArrowRight':
                    {
                        if (selectionAtTheEnd) {
                            ev.preventDefault();
                            onNext?.(ev.key, false);
                        }
                        break;
                    }
                default:
                    {
                        if (isFull(value) && selectionAtTheEnd) {
                            if (/[0-9]/.test(ev.key)) {
                                onNext?.(ev.key, true);
                            }
                        }
                    }
            }
            onKeyDown?.(ev);
        }, [
        updateValue,
        onKeyDown,
        value,
        onPrev,
        onNext,
        isFull,
        numberValue
    ]);
    return /*#__PURE__*/ React.createElement("input", {
        ref: ref,
        step: 1,
        maxLength: getNumberOfDigits(max),
        type: "text",
        inputMode: "numeric",
        pattern: "[0-9]*",
        onKeyDown: handleKeyDown,
        "data-time-field": true,
        onInput: handleChange,
        className: classNames(classes.root, className),
        value: value,
        ...rest
    });
});
ChainableNumberInput.displayName = 'ChainableNumberInput';

//# sourceMappingURL=chainable-number-input.js.map